import "./Legal.css";

const Terms = () => {
  return (
    <div className="legal-page">
      <h1>Terms & Conditions</h1>
      <p><b>Effective Date:</b> 2026-01-01</p>

      <p>
        Welcome to the website. This website is designed and developed by{" "}
        <a href="https://magicapps.co.in/" target="_blank" rel="noopener noreferrer">MagicApps</a>. By accessing or using this website, you agree to be bound by
        the following Terms and Conditions. If you do not agree with any part of
        these terms, please do not use our website.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing, browsing, or using this website, you acknowledge that you
        have read, understood, and agree to be bound by these Terms & Conditions,
        along with our Privacy Policy.
      </p>

      <h2>2. Description of Service</h2>
      <p>
        The website provides an online tool that allows users to view and process
        EPS and related file formats directly in a web browser.
        <br /><br />
        The service is provided <b>“as is”</b> and <b>“as available”</b>, without any
        warranties or guarantees.
      </p>

      <h2>3. User Responsibilities</h2>
      <ul>
        <li>You will use the website only for lawful purposes</li>
        <li>You will not upload illegal or harmful content</li>
        <li>You will not violate intellectual property rights</li>
        <li>You are solely responsible for the files you upload or view</li>
        <li>We do not claim ownership of uploaded files</li>
      </ul>

      <h2>4. File Handling & Data Privacy</h2>
      <ul>
        <li>Uploaded files may be processed temporarily</li>
        <li>We do not intentionally store files permanently</li>
        <li>We are not responsible for data loss or file corruption</li>
        <li>Do not upload sensitive or confidential files</li>
      </ul>

      <h2>5. Intellectual Property Rights</h2>
      <p>
        All content on <b>epsviewer.in</b>, including design, text, graphics,
        logos and code is the intellectual property of epsviewer.in unless
        otherwise stated.
      </p>
      <p>
        You may not copy, modify, distribute, or reproduce any part of the website
        without prior written permission.
      </p>

      <h2>6. Third-Party Services & Ads</h2>
      <p>epsviewer.in may use third-party analytics and ad services.</p>
      <p>We are not responsible for:</p>
      <ul>
        <li>External websites</li>
        <li>Third-party content</li>
        <li>Any damage or loss caused by third-party services</li>
      </ul>
      <p>
        Use of third-party services is subject to their own Terms & Privacy
        Policies.
      </p>

      <h2>7. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, epsviewer.in shall not be liable
        for:
      </p>
      <ul>
        <li>Direct or indirect damages</li>
        <li>Loss of data or business</li>
        <li>Service interruptions or downtime</li>
        <li>Rendering or processing errors</li>
      </ul>
      <p>Your use of the website is entirely at your own risk.</p>

      <h2>8. Service Availability & Modifications</h2>
      <p>We reserve the right to:</p>
      <ul>
        <li>Modify or discontinue features</li>
        <li>Update the service without notice</li>
        <li>Restrict access for maintenance or security</li>
      </ul>

      <h2>9. Termination of Use</h2>
      <p>
        Access may be suspended or terminated without notice if these Terms are
        violated or the service is misused.
      </p>

      <h2>10. Governing Law</h2>
      <p>
        These Terms & Conditions are governed by the laws of India. Any disputes
        will be handled under the jurisdiction of Indian courts.
      </p>

      <h2>11. Changes to These Terms</h2>
      <p>
        We may update these Terms & Conditions from time to time. Continued use
        of the website after changes means you accept the updated terms.
      </p>

      <h2>12. Contact Us</h2>
      <p>
        If you have any questions regarding these Terms & Conditions, please
        contact us at:
        <br />
        <b>support@magicapps.co.in</b>
      </p>
    </div>
  );
};

export default Terms;
